export const TABS = [
	'Wine',
	'Locker',
	'5x5',
	'5x10',
	'5x15',
	'10x10',
	'10x15',
	'10x20',
	'10x25',
	'10x30',
	'10x35',
	'10x40',
	'10x50',
];

export const CONTENT = {
	Wine: {
		title: 'Wine Storage',
		'Square Footage': 'Varies',
		'Looks Like:':
			'Climate controlled locker designed for wine bottle storage',
		'What Will Fit:': 'Size varies, often starting around 6 cases',
	},

	Locker: {
		title: 'Storage Lockers',
		'Square Footage': '25 sq ft or less',
		'Looks Like:': 'Small coat closet or half bathroom',
		'What Will Fit:': 'Clothes, tools, seasonal items, documents',
	},

	'5x5': {
		title: '5x5 Storage',
		'Square Footage': '25 Square Feet',
		'Looks Like:': 'Small closet or half bathroom',
		'What Will Fit:':
			'Holiday decorations, off-season clothing, small boxes',
	},

	'5x10': {
		title: '5x10 Storage',
		'Square Footage': '50 Square Feet',
		'Looks Like:': 'Large walk-in closet',
		'What Will Fit:': 'Studio bedroom set, bicycle, storage boxes',
	},

	'5x15': {
		title: '5x15 Storage',
		'Square Footage': '75 Square Feet',
		'Looks Like:': 'Small bedroom',
		'What Will Fit:': 'Queen mattress, love seat, television, boxes',
	},

	'10x10': {
		title: '10x10 Storage',
		'Square Footage': '100 Square Feet',
		'Looks Like:': 'Bedroom',
		'What Will Fit:': 'Full bedroom set, compact furniture, boxes',
	},

	'10x15': {
		title: '10x15 Storage',
		'Square Footage': '150 Square Feet',
		'Looks Like:': 'Large bedroom',
		'What Will Fit:': 'Contents of a small house or apartment, appliances',
	},

	'10x20': {
		title: '10x20 Storage',
		'Square Footage': '200 Square Feet',
		'Looks Like:': 'One-car garage',
		'What Will Fit:': 'Household items, dining room set, workout equipment',
	},

	'10x25': {
		title: '10x25 Storage',
		'Square Footage': '250 Square Feet',
		'Looks Like:': 'Spacious single-car garage',
		'What Will Fit:':
			'Several bedroom sets, office furniture, and appliances',
	},

	'10x30': {
		title: '10x30 Storage',
		'Square Footage': '300 Square Feet',
		'Looks Like:': 'Two-car garage',
		'What Will Fit:':
			'Items from a large house, bedroom sets, major appliances, seasonal items',
	},

	'10x35': {
		title: '10x35 Storage',
		'Square Footage': '350 Square Feet',
		'Looks Like:': 'Extended garage',
		'What Will Fit:':
			'Large vehicle, moving boxes, or the majority of household contents',
	},

	'10x40': {
		title: '10x40 Storage',
		'Square Footage': '400 Square Feet',
		'Looks Like:': 'Multi-car garage',
		'What Will Fit:':
			'Average recreational vehicle, two sedans, recreational gear',
	},

	'10x50': {
		title: '10x50 Storage',
		'Square Footage': '500 Square Feet',
		'Looks Like:': 'Small warehouse space',
		'What Will Fit:':
			'Complete household contents, vehicles, boats, business inventory',
	},
};
